import React from 'react';

import epncpaLogo from '@assets/ecomm_logo.svg';
import epncpaLogoXs from '@assets/ecomm_logo_xs.svg';

import routes from '@config/routes.json';
import BaseSemanticLink from '../BaseSemanticLink';

export enum LogoTypes {
    primary = 'red',
    secondary = 'white',
}

interface IBaseLogoProps {
    type?: LogoTypes;
    link?: string;
}

const BaseLogo: React.FC<IBaseLogoProps> = ({
    type = LogoTypes.primary,
    link = routes.dashboard,
}) => (
    <BaseSemanticLink className="flex items-center h-full md:mr-10 min-h-10" to={link}>
        {process.env.NEXT_PUBLIC_PROJECT_NAME === 'epn' ? (
            <div className="w-20">
                {type === 'red' ? (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ width: '100%' }}
                        viewBox="0 0 88.01 33.01"
                    >
                        <path
                            d="M37.35 31.17V1.85h12c6.22 0 10.39 3.18 10.39 9.63s-4.17 9.62-10.39 9.62h-6v10.07zm6-24.58v9.77h5.34c3.17 0 4.79-1.8 4.79-4.88s-1.62-4.89-4.79-4.89zm38.42 24.58L70.34 12.92l-1.5-2.74.31 3.11v17.88h-5.44V1.85H70l11.37 18.27 1.52 2.76-.33-3.11V1.85H88v29.32zM22.78 31.75a16.5 16.5 0 10-21.52-8.93 16.5 16.5 0 0021.52 8.93z"
                            fill="red"
                        />
                        <path
                            d="M16.47 26.78a10.27 10.27 0 1110.26-10.27v1.56H9.49a7.16 7.16 0 007 5.6zm-7-11.83h14a7.15 7.15 0 00-14 0z"
                            fill="#fff"
                        />
                    </svg>
                ) : (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ width: '100%' }}
                        viewBox="0 0 88.009 33.009"
                    >
                        <path
                            d="M37.354 31.165V1.845H49.38c6.223 0 10.39 3.183 10.39 9.626 0 6.449-4.167 9.627-10.39 9.627h-5.993v10.067zM43.387 6.58v9.775h5.338c3.173 0 4.79-1.799 4.79-4.884s-1.617-4.885-4.79-4.885h-5.338zm38.384 24.584L70.343 12.917l-1.495-2.742.307 3.111v17.879H63.71V1.845h6.315l11.352 18.269 1.514 2.762-.327-3.111V1.845h5.445v29.32zM31.7 10.19a16.478 16.478 0 11-21.526-8.93A16.51 16.51 0 0131.7 10.19zM6.221 16.505a10.263 10.263 0 0010.256 10.272v-3.111a7.155 7.155 0 01-6.98-5.603h17.236v-1.558a10.256 10.256 0 10-20.512 0zm17.232-1.558H9.497a7.147 7.147 0 0113.957 0z"
                            fill="#fff"
                        />
                    </svg>
                )}
            </div>
        ) : (
            <picture className="w-full">
                <source media="(max-width: 991px)" srcSet={epncpaLogoXs} />
                <img className="w-[140px] max-h-10" src={epncpaLogo} alt="epncpa" />
            </picture>
        )}
        <span className="sr-only">Link to main page</span>
    </BaseSemanticLink>
);

export default BaseLogo;
